// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import request from '@/api/request';

/**
 * @description 验证码
 */
export function captchaApi() {
  return request({
    url: 'captcha',
    method: 'get',
  });
}

/**
 * @description 登录
 */
export function login(data: any) {
  return request({
    url: 'login',
    method: 'post',
    data,
  });
}

/**
 * @description 登录页配置
 */
export function loginConfigApi() {
  return request({
    url: 'login_config',
    method: 'get',
  });
}

/**
 * @description 退出登录
 */
export function logout() {
  return request({
    url: 'logout',
    method: 'get',
  });
}

/**
 * @description 修改密码
 */
export function passwordFormApi() {
  return request({
    url: 'system/admin/edit/password/form',
    method: 'get',
  });
}

/**
 * @description 修改自己的信息
 */
export function editFormApi() {
  return request({
    url: 'system/admin/edit/form',
    method: 'get',
  });
}

/**
 * @description 菜单
 */
export function getMenusApi() {
  return request({
    url: 'menus',
    method: 'get',
  });
}

export function getInfo(token: string) {
  return request({
    url: '/vue-element-admin/user/info',
    method: 'get',
    params: { token },
  });
}

/**
 * @description 标签
 */
export function getBaseInfo() {
  return request({
    url: 'info',
    method: 'get',
  });
}

/**
 * @description 用户标签 -- 列表
 */
export function labelLstApi(data: any) {
  return request({
    url: 'user/label/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户标签 -- 添加表单
 */
export function labelFormApi() {
  return request({
    url: 'user/label/form',
    method: 'get',
  });
}

/**
 * @description 用户标签 -- 编辑表单
 */
export function labelEditApi(id: number | string) {
  return request({
    url: `user/label/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 用户标签 -- 删除
 */
export function labelDeleteApi(id: number | string) {
  return request({
    url: `user/label/${id}`,
    method: 'delete',
  });
}

/**
 * @description 自动标签 -- 添加
 */
export function AutolabelCreateApi(data: any) {
  return request({
    url: 'auto_label/create',
    method: 'post',
    data,
  });
}

/**
 * @description 自动标签 -- 列表
 */
export function AutolabelLstApi(data: any) {
  return request({
    url: 'auto_label/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 自动标签 -- 编辑
 */
export function AutolabelUpdateApi(id: number | string, data: any) {
  return request({
    url: `auto_label/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 自动标签 -- 删除
 */
export function AutolabelDeleteApi(id: number | string) {
  return request({
    url: `auto_label/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 自动标签 -- 更新
 */
export function AutolabelSyncApi(id: number | string) {
  return request({
    url: `auto_label/sync/${id}`,
    method: 'post',
  });
}

/**
 * @description 用户 -- 列表
 */
export function userLstApi(data: any) {
  return request({
    url: 'user/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户 -- 详情消费记录
 */
export function userOrderApi(uid: number | string, data: any) {
  return request({
    url: `user/order/${uid}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户 -- 详情优惠券
 */
export function userCouponApi(uid: number | string, data: any) {
  return request({
    url: `user/coupon/${uid}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户 -- 批量设置分组
 */
export function changeGroupApi(id: number | string) {
  return request({
    url: `user/change_label/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 修改商户基本信息
 */
export function merchantUpdate(data: any) {
  return request({
    url: '/info/update',
    method: 'post',
    data,
  });
}

/**
 * @description 用户搜索信息 -- 列表
 */
export function userSearchLstApi(data: any) {
  return request({
    url: 'user/search_log',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户搜索信息 -- 一键清空
 */
export function recordClearApi() {
  return request({
    url: 'user/clear_search_log',
    method: 'get',
  });
}

/**
 * 获取版权信息
 */
export function getVersion() {
  return request({
    url: '../api/version',
    method: 'get',
  });
}

/**
 * @description 付费会员记录 -- 列表
 */
export function memberRecordListApi(data: any) {
  return request({
    url: 'user/svip/order_lst',
    method: 'get',
    params: data,
  });
}



/**
 * @description 用户搜索信息 -- 导出
 */
export function recordListImportApi(data:any) {
  return request({
    url: "user/search_log/export",
    method: 'get',
    params: data,
  });
}